import React, { useState } from 'react'
import { router, usePage } from '@inertiajs/react'
import Box from '@mui/material/Box'
import { SidebarLayout } from '@/components/layouts/SidebarLayout'
import { BoardWizardDialog } from '@/components/tasks/BoardWizardDialog'

interface ProjectOption {
  id: number
  name: string
  slug: string
}

interface Props {
  projects: ProjectOption[]
}

export default function New({ projects }: Props) {
  const { current_agent } = usePage().props as { current_agent?: { id: number } }
  const [open, setOpen] = useState(true)

  function handleClose() {
    setOpen(false)
    router.visit('/manage/boards')
  }

  return (
    <SidebarLayout section="manage" title="New board">
      <Box />
      <BoardWizardDialog
        open={open}
        onClose={handleClose}
        projects={projects.map((p) => ({ id: p.id, name: p.name }))}
        currentAgentId={current_agent?.id ?? 0}
        submitUrl="/manage/boards"
      />
    </SidebarLayout>
  )
}
